module.exports = {
	"fr": {
		"conversation": {
			"widget": {
				"title": "Chattez avec nous"
			}
		}
	}
};